import React from "react";
import styles from "../styles/DeleteConfirmationModal.module.css";

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  workflowName,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3>Delete Workflow</h3>
        <p>
          Are you sure you want to delete <strong>{workflowName}</strong>? This
          action cannot be undone.
        </p>
        <div className={styles.modalActions}>
          <button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </button>
          <button className={styles.deleteButton} onClick={onConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
